import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Tillykke! Du har optjent {{amount}} i cashback.',
  },
};
